import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';

// Modules metier utilises
import { UserModule } from '../../humain/user/user.module';

// Composants metiers
import { AgenceFilterableSelectorComponent } from './components/agence-filterable-selector.component';
import { AgenceSelectorComponent } from './components/agence-selector.component';

// Services metier
import { AgenceService } from './services/agence.service';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,

		CheckboxListModule,

		UserModule,

		FilterableSelectModule,
	],
	providers: [
		AgenceService,
	],
	declarations: [
		AgenceFilterableSelectorComponent,
		AgenceSelectorComponent,
	],
	exports: [
		AgenceFilterableSelectorComponent,
		AgenceSelectorComponent,
	]
})
export class AgenceModule {
	constructor() { }
}